import { render } from "./ItemDescription.vue?vue&type=template&id=8aecc244"
import script from "./ItemDescription.vue?vue&type=script&lang=js"
export * from "./ItemDescription.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__